import { useMemo, useState } from 'react';
import { JsonDiff } from '../JsonDiff';

interface ReviewStepProps {
  currentDescription: string;
  editedDescription: string;
  onEditedChange: (value: string) => void;
}

function isValidJson(raw: string): boolean {
  try {
    JSON.parse(raw);
    return true;
  } catch {
    return false;
  }
}

export function ReviewStep({
  currentDescription,
  editedDescription,
  onEditedChange,
}: ReviewStepProps) {
  const [mode, setMode] = useState<'diff' | 'edit'>('diff');
  const valid = useMemo(() => isValidJson(editedDescription), [editedDescription]);

  return (
    <div className="refine-step refine-step--review">
      <div className="refine-step__header">
        <h3 className="refine-step__title">Review the proposed changes</h3>
        <div className="refine-step__view-toggle">
          <button
            type="button"
            className={
              'refine-step__tab' +
              (mode === 'diff' ? ' refine-step__tab--active' : '')
            }
            onClick={() => setMode('diff')}
          >
            Diff view
          </button>
          <button
            type="button"
            className={
              'refine-step__tab' +
              (mode === 'edit' ? ' refine-step__tab--active' : '')
            }
            onClick={() => setMode('edit')}
          >
            Edit updated JSON
          </button>
        </div>
      </div>

      {mode === 'diff' ? (
        <JsonDiff
          original={currentDescription}
          updated={editedDescription}
          variant="split"
          className="refine-step__diff"
        />
      ) : (
        <div className="refine-step__editor">
          <div className="refine-step__editor-col">
            <h4>Current (read-only)</h4>
            <pre className="refine-step__editor-readonly">
              {currentDescription}
            </pre>
          </div>
          <div className="refine-step__editor-col">
            <h4>Updated (editable)</h4>
            <textarea
              className={
                'refine-step__editor-textarea' +
                (valid ? '' : ' refine-step__editor-textarea--invalid')
              }
              value={editedDescription}
              onChange={(e) => onEditedChange(e.target.value)}
              spellCheck={false}
            />
            {!valid && (
              <p className="refine-step__editor-error">Invalid JSON</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
